// Source: app/scripts/directives/show-html.js
/**
 * Created by riste_000 on 3/15/2015.
 */


Auction.directive('showHtml', [
  '$compile',
  function ($compile) {
    return {
      restrict: 'A',
      scope: {
        html: '='
      },
      link: function (scope, element, attrs) {
        if(scope.html) {
          element.html('');
          element.append($compile(scope.html)(scope));
        }
        scope.$watch('html', function (value) {
          if (value) {
            element.html('');
            element.append($compile(value)(scope));
          }
        });

      }
    };
  }]);
